// import './Avis.scss'
// import React from 'react'
// import Stars from '../Stars/Stars'

// function Avis() {
//     return (
//         <section
//             id="avis"
//             className="testimonials"
//             aria-label="Avis clients"
//         >
//             <div className="testimonials__container">
//                 <div
//                     className="testimonials__grid"
//                     role="list"
//                 >
//                     <figure
//                         className="testimonials__card"
//                         role="listitem"
//                     >
//                         <div className="testimonials__card__stars" aria-label="Note de 5 étoiles sur 5">
//                             <Stars />
//                         </div>

//                         <blockquote className="testimonials__quote">
//                             <p>
//                                 “Jusqu’à présent, je n'avais qu'un site WordPress autogéré.
//                                 Le travail avec Benjamin a donné une autre dimension à ma
//                                 vitrine Web. Un excellent travail, à l'écoute des envies
//                                 artistiques et des besoins techniques. Une interface adaptée
//                                 et une bonne identité visuelle, cohérente avec ma demande.
//                                 Toujours disponible, créatif, réactif, rigoureux et de bon
//                                 conseil, il a toujours été clair dans nos échanges.
//                                 Je recommande !”
//                             </p>
//                         </blockquote>

//                         <figcaption className="testimonials__author">
//                             <strong>C.D — Scénographe</strong>
//                         </figcaption>
//                     </figure>

//                     <figure
//                         className="testimonials__card"
//                         role="listitem"
//                     >
//                         <div className="testimonials__card__stars" aria-label="Note de 5 étoiles sur 5">
//                             <Stars />
//                         </div>

//                         <blockquote className="testimonials__quote">
//                             <p>“Tout était parfait !”</p>
//                         </blockquote>

//                         <figcaption className="testimonials__author">
//                             <strong>C.V — Directeur artistique</strong>
//                         </figcaption>
//                     </figure>

//                     <figure
//                         className="testimonials__card"
//                         role="listitem"
//                     >
//                         <div className="testimonials__card__stars" aria-label="Note de 5 étoiles sur 5">
//                             <Stars />
//                         </div>

//                         <blockquote className="testimonials__quote">
//                             <p>
//                                 “Benjamin a compris les enjeux du projet en un
//                                 claquement de doigts. Propositions pertinentes,
//                                 réactif, à l'écoute, efficace. Résultat nickel.”
//                             </p>
//                         </blockquote>

//                         <figcaption className="testimonials__author">
//                             <strong>O.B — Directeur artistique</strong>
//                         </figcaption>
//                     </figure>
//                 </div>
//             </div>
//         </section>
//     )
// }

// export default Avis

import './Avis.scss'
import React, { useEffect, useRef, useState } from 'react'
import Stars from '../Stars/Stars'

function Avis() {
    const gridRef = useRef(null)
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting)
            },
            {
                root: null,
                threshold: 0,
                rootMargin: '0px 0px -50px 0px'
            }
        )

        const grid = gridRef.current

        if (grid) {
            observer.observe(grid)
        }

        return () => {
            if (grid) {
                observer.unobserve(grid)
            }
        }
    }, [])

    return (
        <section
            id="avis"
            className="testimonials"
            aria-label="Avis clients"
        >
            <div className="testimonials__container">
                <div
                    ref={gridRef}
                    className={`testimonials__grid ${isVisible ? 'visible' : ''}`}
                    role="list"
                >
                    <figure
                        className="testimonials__card testimonials__card--1"
                        role="listitem"
                    >
                        <div
                            className="testimonials__card__stars"
                            aria-label="Note de 5 étoiles sur 5"
                        >
                            <Stars />
                        </div>

                        <blockquote className="testimonials__quote">
                            <p>
                                “Jusqu’à présent, je n'avais qu'un site WordPress autogéré.
                                Le travail avec Benjamin a donné une autre dimension à ma
                                vitrine Web. Un excellent travail, à l'écoute des envies
                                artistiques et des besoins techniques. Une interface adaptée
                                et une bonne identité visuelle, cohérente avec ma demande.
                                Toujours disponible, créatif, réactif, rigoureux et de bon
                                conseil, il a toujours été clair dans nos échanges.
                                Je recommande !”
                            </p>
                        </blockquote>

                        <figcaption className="testimonials__author">
                            <strong>C.D — Scénographe</strong>
                        </figcaption>
                    </figure>

                    <figure
                        className="testimonials__card testimonials__card--2"
                        role="listitem"
                    >
                        <div
                            className="testimonials__card__stars"
                            aria-label="Note de 5 étoiles sur 5"
                        >
                            <Stars />
                        </div>

                        <blockquote className="testimonials__quote">
                            <p>“Tout était parfait !”</p>
                        </blockquote>

                        <figcaption className="testimonials__author">
                            <strong>C.V — Directeur artistique</strong>
                        </figcaption>
                    </figure>

                    <figure
                        className="testimonials__card testimonials__card--3"
                        role="listitem"
                    >
                        <div
                            className="testimonials__card__stars"
                            aria-label="Note de 5 étoiles sur 5"
                        >
                            <Stars />
                        </div>

                        <blockquote className="testimonials__quote">
                            <p>
                                “Benjamin a compris les enjeux du projet en un
                                claquement de doigts. Propositions pertinentes,
                                réactif, à l'écoute, efficace. Résultat nickel.”
                            </p>
                        </blockquote>

                        <figcaption className="testimonials__author">
                            <strong>O.B — Directeur artistique</strong>
                        </figcaption>
                    </figure>
                </div>
            </div>
        </section>
    )
}

export default Avis